"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6950],{

/***/ 51455:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _constants = __webpack_require__(13294);
var _packageorcombined = __webpack_require__(98683);
var isEligibleScale = function(scale) {
    return !(0, _fp.isNil)(scale) && (0, _fp.includes)(scale, [
        _constants.SCALE.SINGLE_PARENT,
        _constants.SCALE.SINGLE_PARENT_PLUS_21,
        _constants.SCALE.COUPLE,
        _constants.SCALE.FAMILY,
        _constants.SCALE.FAMILY_PLUS_21
    ]);
};
var _default = {
    id: '100-off',
    isEligible: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        return !(0, _fp.isNil)(productId) && isEligibleScale(scale) && (0, _packageorcombined.isEligible)({
            productId: productId
        });
    },
    isUpsellApplicable: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        return !(0, _fp.isNil)(productId) && isEligibleScale(scale) && (0, _packageorcombined.isUpsellApplicable)({
            productId: productId
        });
    }
};


/***/ }),

/***/ 72732:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _constants = __webpack_require__(13294);
var _packageorcombined = __webpack_require__(98683);
var isEligibleScale = function(scale) {
    return !(0, _fp.isNil)(scale) && scale === _constants.SCALE.SINGLE;
};
var _default = {
    id: '50-off',
    isEligible: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        return !(0, _fp.isNil)(productId) && isEligibleScale(scale) && (0, _packageorcombined.isEligible)({
            productId: productId
        });
    },
    isUpsellApplicable: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        return !(0, _fp.isNil)(productId) && isEligibleScale(scale) && (0, _packageorcombined.isUpsellApplicable)({
            productId: productId
        });
    }
};


/***/ }),

/***/ 73647:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _100off = /*#__PURE__*/ _interop_require_default(__webpack_require__(51455));
var _50off = /*#__PURE__*/ _interop_require_default(__webpack_require__(72732));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: '100off',
    rewards: [
        _50off.default,
        _100off.default
    ]
};


/***/ }),

/***/ 74456:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _packageorcombined = __webpack_require__(98683);
var _default = {
    id: '12wf',
    rewards: [
        {
            id: '12-weeks-free',
            isEligible: _packageorcombined.isEligible,
            isUpsellApplicable: _packageorcombined.isUpsellApplicable
        }
    ]
};


/***/ }),

/***/ 76926:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _packageorcombined = __webpack_require__(98683);
var _default = {
    id: '12wfpb',
    rewards: [
        {
            id: '12-weeks-free',
            isEligible: _packageorcombined.isEligible,
            isUpsellApplicable: _packageorcombined.isUpsellApplicable
        }
    ]
};


/***/ }),

/***/ 72594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _packageorcombined = __webpack_require__(98683);
var _default = {
    id: '1mf',
    rewards: [
        {
            id: '1-month-free',
            isEligible: _packageorcombined.isEligible,
            isUpsellApplicable: _packageorcombined.isUpsellApplicable
        }
    ]
};


/***/ }),

/***/ 2526:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _tieredfinancialrewards = /*#__PURE__*/ _interop_require_default(__webpack_require__(63399));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: '200gc',
    rewards: _tieredfinancialrewards.default.createRewards('giftcard')
};


/***/ }),

/***/ 58806:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _tieredfinancialrewards = /*#__PURE__*/ _interop_require_default(__webpack_require__(63399));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: '200off',
    rewards: _tieredfinancialrewards.default.createRewards('off')
};


/***/ }),

/***/ 79295:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _packageorcombined = __webpack_require__(98683);
var _default = {
    id: '6wf',
    rewards: [
        {
            id: '6-weeks-free',
            isEligible: _packageorcombined.isEligible,
            isUpsellApplicable: _packageorcombined.isUpsellApplicable
        }
    ]
};


/***/ }),

/***/ 79067:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _sixweeksfree = /*#__PURE__*/ _interop_require_default(__webpack_require__(87458));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: '6wfeo',
    rewards: [
        _sixweeksfree.default
    ]
};


/***/ }),

/***/ 87458:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _constants = __webpack_require__(13294);
var _getproducttypefromproductid = /*#__PURE__*/ _interop_require_default(__webpack_require__(62219));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: '6-weeks-free-extras-only',
    isEligible: function() {
        var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
        if (!productId) return false;
        var productType = (0, _getproducttypefromproductid.default)(productId);
        return productType === _constants.PRODUCT_TYPE.EXTRAS;
    },
    isExtrasOnly: function() {
        return true;
    }
};


/***/ }),

/***/ 74800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _sixweeksfree = /*#__PURE__*/ _interop_require_default(__webpack_require__(87458));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: '6wfeopb',
    rewards: [
        _sixweeksfree.default
    ]
};


/***/ }),

/***/ 14652:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _constants = __webpack_require__(13294);
var _getproducttypefromproductid = /*#__PURE__*/ _interop_require_default(__webpack_require__(62219));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: '6wfho',
    rewards: [
        {
            id: '6-weeks-free-hospital-only',
            isEligible: function() {
                var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
                if (!productId) return false;
                var productType = (0, _getproducttypefromproductid.default)(productId);
                return productType === _constants.PRODUCT_TYPE.HOSPITAL;
            },
            isHospitalOnly: function() {
                return true;
            }
        }
    ]
};


/***/ }),

/***/ 20025:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _packageorcombined = __webpack_require__(98683);
var _default = {
    id: '8wf',
    rewards: [
        {
            id: '8-weeks-free',
            isEligible: _packageorcombined.isEligible,
            isUpsellApplicable: _packageorcombined.isUpsellApplicable
        }
    ]
};


/***/ }),

/***/ 49018:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _default = {
    id: '8wfap',
    rewards: [
        {
            id: '8-weeks-free-all-products',
            isEligible: function() {
                var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
                if (!productId) return false;
                return true;
            }
        }
    ]
};


/***/ }),

/***/ 27794:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _constants = __webpack_require__(13294);
var _getproducttypefromproductid = /*#__PURE__*/ _interop_require_default(__webpack_require__(62219));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: '8wfeo',
    rewards: [
        {
            id: '8-weeks-free-extras-only',
            isEligible: function() {
                var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
                if (!productId) return false;
                var productType = (0, _getproducttypefromproductid.default)(productId);
                return productType === _constants.PRODUCT_TYPE.EXTRAS;
            },
            isExtrasOnly: function() {
                return true;
            }
        }
    ]
};


/***/ }),

/***/ 10108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _default = {
    id: 'cashrewards-10-percent',
    rewards: [
        {
            id: '10-percent-cashback',
            isEligible: function() {
                var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
                return !(0, _fp.isUndefined)(productId);
            }
        }
    ]
};


/***/ }),

/***/ 68272:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _default = {
    id: 'cashrewards-12-percent',
    rewards: [
        {
            id: '12-percent-cashback',
            isEligible: function() {
                var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
                return !(0, _fp.isUndefined)(productId);
            }
        }
    ]
};


/***/ }),

/***/ 35698:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _default = {
    id: 'cashrewards-6-percent',
    rewards: [
        {
            id: '6-percent-cashback',
            isEligible: function() {
                var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
                return !(0, _fp.isUndefined)(productId);
            }
        }
    ]
};


/***/ }),

/***/ 9298:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _default = {
    id: 'cashrewards-8-percent',
    rewards: [
        {
            id: '8-percent-cashback',
            isEligible: function() {
                var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
                return !(0, _fp.isUndefined)(productId);
            }
        }
    ]
};


/***/ }),

/***/ 81778:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _default = {
    id: 'fnd',
    rewards: []
};


/***/ }),

/***/ 56950:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _cashrewards6percent = /*#__PURE__*/ _interop_require_default(__webpack_require__(35698));
var _cashrewards8percent = /*#__PURE__*/ _interop_require_default(__webpack_require__(9298));
var _cashrewards10percent = /*#__PURE__*/ _interop_require_default(__webpack_require__(10108));
var _cashrewards12percent = /*#__PURE__*/ _interop_require_default(__webpack_require__(68272));
var _8wf = /*#__PURE__*/ _interop_require_default(__webpack_require__(20025));
var _8wfap = /*#__PURE__*/ _interop_require_default(__webpack_require__(49018));
var _8wfeo = /*#__PURE__*/ _interop_require_default(__webpack_require__(27794));
var _fnd = /*#__PURE__*/ _interop_require_default(__webpack_require__(81778));
var _200gc = /*#__PURE__*/ _interop_require_default(__webpack_require__(2526));
var _k60 = /*#__PURE__*/ _interop_require_default(__webpack_require__(71585));
var _100off = /*#__PURE__*/ _interop_require_default(__webpack_require__(73647));
var _200off = /*#__PURE__*/ _interop_require_default(__webpack_require__(58806));
var _1mf = /*#__PURE__*/ _interop_require_default(__webpack_require__(72594));
var _pickleball = /*#__PURE__*/ _interop_require_default(__webpack_require__(62982));
var _rww = /*#__PURE__*/ _interop_require_default(__webpack_require__(9964));
var _ref = /*#__PURE__*/ _interop_require_default(__webpack_require__(93295));
var _santos = /*#__PURE__*/ _interop_require_default(__webpack_require__(99187));
var _6wf = /*#__PURE__*/ _interop_require_default(__webpack_require__(79295));
var _6wfeo = /*#__PURE__*/ _interop_require_default(__webpack_require__(79067));
var _6wfeopb = /*#__PURE__*/ _interop_require_default(__webpack_require__(74800));
var _6wfho = /*#__PURE__*/ _interop_require_default(__webpack_require__(14652));
var _swag = /*#__PURE__*/ _interop_require_default(__webpack_require__(43294));
var _teamapp = /*#__PURE__*/ _interop_require_default(__webpack_require__(10116));
var _t1m = /*#__PURE__*/ _interop_require_default(__webpack_require__(39470));
var _12wf = /*#__PURE__*/ _interop_require_default(__webpack_require__(74456));
var _12wfpb = /*#__PURE__*/ _interop_require_default(__webpack_require__(76926));
var _ww = /*#__PURE__*/ _interop_require_default(__webpack_require__(45348));
var _wwpb = /*#__PURE__*/ _interop_require_default(__webpack_require__(62663));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _obj;
var _default = (_obj = {}, _define_property(_obj, _cashrewards6percent.default.id, _cashrewards6percent.default), _define_property(_obj, _cashrewards8percent.default.id, _cashrewards8percent.default), _define_property(_obj, _cashrewards10percent.default.id, _cashrewards10percent.default), _define_property(_obj, _cashrewards12percent.default.id, _cashrewards12percent.default), _define_property(_obj, _8wf.default.id, _8wf.default), _define_property(_obj, _8wfap.default.id, _8wfap.default), _define_property(_obj, _8wfeo.default.id, _8wfeo.default), _define_property(_obj, _fnd.default.id, _fnd.default), _define_property(_obj, _200gc.default.id, _200gc.default), _define_property(_obj, _k60.default.id, _k60.default), _define_property(_obj, _100off.default.id, _100off.default), _define_property(_obj, _200off.default.id, _200off.default), _define_property(_obj, _1mf.default.id, _1mf.default), _define_property(_obj, _pickleball.default.id, _pickleball.default), _define_property(_obj, _rww.default.id, _rww.default), _define_property(_obj, _ref.default.id, _ref.default), _define_property(_obj, _santos.default.id, _santos.default), _define_property(_obj, _6wf.default.id, _6wf.default), _define_property(_obj, _6wfeo.default.id, _6wfeo.default), _define_property(_obj, _6wfeopb.default.id, _6wfeopb.default), _define_property(_obj, _6wfho.default.id, _6wfho.default), _define_property(_obj, _swag.default.id, _swag.default), _define_property(_obj, _teamapp.default.id, _teamapp.default), _define_property(_obj, _t1m.default.id, _t1m.default), _define_property(_obj, _12wf.default.id, _12wf.default), _define_property(_obj, _12wfpb.default.id, _12wfpb.default), _define_property(_obj, _ww.default.id, _ww.default), _define_property(_obj, _wwpb.default.id, _wwpb.default), _obj);


/***/ }),

/***/ 71585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _packageorcombined = __webpack_require__(98683);
var _default = {
    id: 'k60',
    rewards: [
        {
            id: 'kogan-60-credit',
            isEligible: _packageorcombined.isEligible,
            isUpsellApplicable: function() {
                return false;
            }
        }
    ]
};


/***/ }),

/***/ 62982:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _default = {
    id: 'pickleball',
    rewards: []
};


/***/ }),

/***/ 93295:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _default = {
    id: 'ref',
    rewards: []
};


/***/ }),

/***/ 9964:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _waivewaits = /*#__PURE__*/ _interop_require_default(__webpack_require__(93154));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: 'rww',
    rewards: [
        _waivewaits.default
    ]
};


/***/ }),

/***/ 99187:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _default = {
    id: 'santos',
    rewards: []
};


/***/ }),

/***/ 98683:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isEligible: function() {
        return isEligible;
    },
    isUpsellApplicable: function() {
        return isUpsellApplicable;
    }
});
var _fp = __webpack_require__(78230);
var _constants = __webpack_require__(13294);
var _getproducttypefromproductid = /*#__PURE__*/ _interop_require_default(__webpack_require__(62219));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isPackageOrCombined = function(productType) {
    return (0, _fp.includes)(productType, [
        _constants.PRODUCT_TYPE.PACKAGE,
        _constants.PRODUCT_TYPE.COMBINED
    ]);
};
var isEligible = function() {
    var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
    if (!productId) return false;
    var productType = (0, _getproducttypefromproductid.default)(productId);
    return isPackageOrCombined(productType);
};
var isUpsellApplicable = function() {
    var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
    if (!productId) return false;
    var productType = (0, _getproducttypefromproductid.default)(productId);
    return !isPackageOrCombined(productType);
};


/***/ }),

/***/ 63190:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _constants = __webpack_require__(13294);
var _index = __webpack_require__(12921);
var isSingleParent = function(scale) {
    return (0, _fp.includes)(scale, [
        _constants.SCALE.SINGLE_PARENT,
        _constants.SCALE.SINGLE_PARENT_PLUS_21
    ]);
};
var _default = {
    id: '100',
    isEligible: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        if (!productId || !scale) return false;
        if (scale === _constants.SCALE.COUPLE && (0, _index.isLowerValuePackageOrCombined)(productId)) return true;
        if (isSingleParent(scale) && (0, _index.isPackageOrCombined)(productId)) return true;
        return scale === _constants.SCALE.SINGLE && !(0, _index.isLowerValuePackageOrCombined)(productId) && (0, _index.isPackageOrCombined)(productId);
    },
    isUpsellApplicable: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        if (!productId || !scale) return false;
        if (scale === _constants.SCALE.COUPLE && (0, _index.isLowerValueHospitalOrExtras)(productId)) return true;
        if (isSingleParent(scale) && !(0, _index.isPackageOrCombined)(productId)) return true;
        return scale === _constants.SCALE.SINGLE && !(0, _index.isLowerValueHospitalOrExtras)(productId) && !(0, _index.isPackageOrCombined)(productId);
    }
};


/***/ }),

/***/ 59540:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _constants = __webpack_require__(13294);
var _index = __webpack_require__(12921);
var isFamily = function(scale) {
    return (0, _fp.includes)(scale, [
        _constants.SCALE.FAMILY,
        _constants.SCALE.FAMILY_PLUS_21
    ]);
};
var _default = {
    id: '200',
    isEligible: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        if (!productId || !scale) return false;
        if (!(0, _index.isPackageOrCombined)(productId)) return false;
        return scale === _constants.SCALE.COUPLE && !(0, _index.isLowerValuePackageOrCombined)(productId) || isFamily(scale);
    },
    isUpsellApplicable: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        if (!productId || !scale) return false;
        return scale === _constants.SCALE.COUPLE && !(0, _index.isPackageOrCombined)(productId) && !(0, _index.isLowerValueHospitalOrExtras)(productId) || isFamily(scale) && !(0, _index.isPackageOrCombined)(productId);
    }
};


/***/ }),

/***/ 24594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _constants = __webpack_require__(13294);
var _index = __webpack_require__(12921);
var _default = {
    id: '50',
    isEligible: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        if (!productId || !scale) return false;
        return scale === _constants.SCALE.SINGLE && (0, _index.isLowerValuePackageOrCombined)(productId);
    },
    isUpsellApplicable: function() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productId = _ref.productId, scale = _ref.scale;
        if (!productId || !scale) return false;
        return scale === _constants.SCALE.SINGLE && (0, _index.isLowerValueHospitalOrExtras)(productId);
    }
};


/***/ }),

/***/ 63399:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _50 = /*#__PURE__*/ _interop_require_default(__webpack_require__(24594));
var _100 = /*#__PURE__*/ _interop_require_default(__webpack_require__(63190));
var _200 = /*#__PURE__*/ _interop_require_default(__webpack_require__(59540));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var createRewards = function(id) {
    return (0, _fp.map)(function(reward) {
        return (0, _fp.defaults)(reward, {
            id: "".concat(reward.id, "-").concat(id)
        });
    }, [
        _50.default,
        _100.default,
        _200.default
    ]);
};
var _default = {
    createRewards: createRewards
};


/***/ }),

/***/ 12921:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isLowerValueHospitalOrExtras: function() {
        return isLowerValueHospitalOrExtras;
    },
    isLowerValuePackageOrCombined: function() {
        return isLowerValuePackageOrCombined;
    },
    isPackageOrCombined: function() {
        return isPackageOrCombined;
    }
});
var _fp = __webpack_require__(78230);
var _constants = __webpack_require__(13294);
var _getproducttypefromproductid = /*#__PURE__*/ _interop_require_default(__webpack_require__(62219));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ELIGIBLE_PRODUCTS_PACKAGE_OR_COMBINED = [
    _constants.PRODUCT.STARTER_BASIC_EXCESS_500_BLACK_50_EXTRAS,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_750_BLACK_50_EXTRAS,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_500_BLACK_50_SAVER_EXTRAS,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_750_BLACK_50_SAVER_EXTRAS,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_500_CHOOSABLE_50_TEETH,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_750_CHOOSABLE_50_TEETH,
    _constants.PRODUCT.STARTER_FLEXI_BASIC_EXCESS_500,
    _constants.PRODUCT.STARTER_FLEXI_BASIC_EXCESS_750,
    _constants.PRODUCT.STARTER_PACKAGE_BASIC_EXCESS_500,
    _constants.PRODUCT.STARTER_PACKAGE_BASIC_EXCESS_750
];
var ELIGIBLE_PRODUCTS_HOSPITAL_OR_EXTRAS = [
    _constants.PRODUCT.STARTER_BASIC_EXCESS_500,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_750,
    _constants.PRODUCT.BLACK_50_EXTRAS,
    _constants.PRODUCT.BLACK_50_SAVER_EXTRAS
];
var isLowerValuePackageOrCombined = function(productId) {
    return (0, _fp.includes)(productId, ELIGIBLE_PRODUCTS_PACKAGE_OR_COMBINED);
};
var isLowerValueHospitalOrExtras = function(productId) {
    return (0, _fp.includes)(productId, ELIGIBLE_PRODUCTS_HOSPITAL_OR_EXTRAS);
};
var isPackageOrCombined = (0, _fp.memoize)(function(productId) {
    return (0, _fp.includes)((0, _getproducttypefromproductid.default)(productId), [
        _constants.PRODUCT_TYPE.COMBINED,
        _constants.PRODUCT_TYPE.PACKAGE
    ]);
});


/***/ }),

/***/ 62219:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _constants = __webpack_require__(13294);
var getProductTypeFromProductId = function(productId) {
    return (0, _fp.findKey)(function(products) {
        return (0, _fp.includes)(productId, (0, _fp.values)(products));
    }, _constants.PRODUCTS_BY_TYPE) || null;
};
var _default = getProductTypeFromProductId;


/***/ }),

/***/ 43294:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _default = {
    id: 'swag',
    rewards: []
};


/***/ }),

/***/ 39470:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _packageorcombined = __webpack_require__(98683);
var _default = {
    id: 't1m',
    rewards: [
        {
            id: '1-month-free',
            isEligible: _packageorcombined.isEligible,
            isUpsellApplicable: _packageorcombined.isUpsellApplicable
        }
    ]
};


/***/ }),

/***/ 10116:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _default = {
    id: 'teamapp',
    rewards: []
};


/***/ }),

/***/ 45348:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _waivewaits = /*#__PURE__*/ _interop_require_default(__webpack_require__(93154));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: 'ww',
    rewards: [
        _waivewaits.default
    ]
};


/***/ }),

/***/ 93154:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _constants = __webpack_require__(13294);
var _getproducttypefromproductid = /*#__PURE__*/ _interop_require_default(__webpack_require__(62219));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var EXCLUDED_EXTRAS = [
    _constants.PRODUCT.CLASSIC_EXTRAS,
    _constants.PRODUCT.FAMILY_EXTRAS,
    _constants.PRODUCT.LIFESTYLE_EXTRAS,
    _constants.PRODUCT.SUPER_EXTRAS
];
var _default = {
    id: 'waive-waits',
    isEligible: function() {
        var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
        if (!productId) return false;
        var productType = (0, _getproducttypefromproductid.default)(productId);
        if (productType === _constants.PRODUCT_TYPE.PACKAGE) {
            return true;
        }
        if (productType === _constants.PRODUCT_TYPE.COMBINED) {
            var extrasComponent = (0, _fp.get)('extras', _constants.COMBINED_PRODUCT_COMPONENTS[productId]);
            if (!(0, _fp.includes)(extrasComponent, EXCLUDED_EXTRAS)) {
                return true;
            }
        }
        return false;
    },
    isRestrictedUpsell: function() {
        var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
        var productType = (0, _getproducttypefromproductid.default)(productId);
        return productType === _constants.PRODUCT_TYPE.HOSPITAL;
    },
    isUpsellApplicable: function() {
        var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
        if (!productId) return false;
        var productType = (0, _getproducttypefromproductid.default)(productId);
        if (productType === _constants.PRODUCT_TYPE.HOSPITAL) {
            return true;
        }
        if (productType === _constants.PRODUCT_TYPE.EXTRAS && !(0, _fp.includes)(productId, EXCLUDED_EXTRAS)) {
            return true;
        }
        return false;
    }
};


/***/ }),

/***/ 62663:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// pickleball offers need their own offer types but are duplicate rewards of the standard ww

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _waivewaits = /*#__PURE__*/ _interop_require_default(__webpack_require__(93154));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: 'wwpb',
    rewards: [
        _waivewaits.default
    ]
};


/***/ })

}]);